// @i18n-ignore-file
export const LOCAL_STORAGE_NEW_CART_ID_KEY = 'new::cart::key::lastbrand'
export const LOCAL_STORAGE_CART_OBJ_KEY = 'new::cart::data::lastbrand'
export const LOCAL_STORAGE_PREV_CART_ID_KEY = 'prev::cart::key::lastbrand'
export const CART_AUTH_CODE_KEY = 'cart::code::key::A'
export const PRIORITY_INVENTORY_TYPE = ['NORMAL', 'MTO', 'PRE_ORDER']
export const CART_AUTH_CODE_RES_KEY = 'auth-code'
export const CHECKOUT_TEST_KEY_VALUE = 'checkout_dev_view'
export const CHECKOUT_TEST_PARAM_VALUE = 'checkout_dev_view'
export const SIDE_TOAST_ERROR_KEY = 'Side:Toast:Error'
